/**
 * Navigation Configuration
 * 
 * Defines all navigation items for the website.
 */

export const NAV_ITEMS = [
  { id: 'about', label: 'About', href: '#about' },
  { id: 'services', label: 'Services', href: '#services' },
  { id: 'why-us', label: 'Why Us', href: '#why-us' },
  { id: 'contact', label: 'Contact', href: '#contact' },
  { id: 'careers', label: 'Careers', href: '/careers' },
];

export const FOOTER_LINKS = {
  quickLinks: [
    { label: 'About', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Why Us', href: '#why-us' },
    { label: 'Contact', href: '#contact' },
    { label: 'Careers', href: '/careers' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Cookie Policy', href: '/cookie-policy' },
    { label: 'Terms of Service', href: '/terms' },
  ],
};
